import { NavLink, Routes, Route, Navigate } from 'react-router-dom';
import DataOperationsTab from '../components/analytics/DataOperationsTab';
import TopicsTab from '../components/analytics/TopicsTab';

function DataOperationsPage() {
  const tabLinkClasses = ({ isActive }) =>
    `pb-4 px-2 font-medium transition ${
      isActive
        ? 'text-primary-600 border-b-2 border-primary-600'
        : 'text-gray-500 hover:text-gray-700'
    }`;

  return (
    <div className="px-6 py-4">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Data Operations</h1>
      </div>

      {/* Sub-tab navigation */}
      <div className="mb-6 border-b border-gray-200">
        <nav className="flex gap-4">
          <NavLink
            to="/data-operations/operations"
            className={tabLinkClasses}
            data-testid="dataops-tab-operations"
          >
            Operations
          </NavLink>
          <NavLink
            to="/data-operations/topics"
            className={tabLinkClasses}
            data-testid="dataops-tab-topics"
          >
            Topics
          </NavLink>
        </nav>
      </div>

      {/* Sub-tab content via nested routes */}
      <Routes>
        <Route index element={<Navigate to="operations" replace />} />
        <Route path="operations" element={<DataOperationsTab />} />
        <Route path="topics" element={<TopicsTab />} />
        <Route path="*" element={<Navigate to="operations" replace />} />
      </Routes>
    </div>
  );
}

export default DataOperationsPage;
